// src/constants.js
var KNOWN_CAMPAIGN_AND_AFFILIATE_QUERY_PARAMS = [
  "affC",
  "adId",
  "advp",
  "at",
  "ct",
  "itsct",
  "itscg",
  "itscc",
  "itcCt",
  "its_qt",
  "ls",
  "partnerId",
  "pt",
  "qtkid",
  "uo"
];
var KNOWN_MARKETING_QUERY_PARAMS = [
  "mttn3pid",
  "mttnagencyid",
  "mttncc",
  "mttnmyad",
  "mttnmyadg",
  "mttnmycmp",
  "mttnmykw",
  "mttnmypla",
  "mttnmypub",
  "mttnmysite",
  "mttnpid",
  "mttnrefid",
  "mttnsiteid",
  "mttnsub1",
  "mttnsub2",
  "mttnsub3",
  "mttnsubad",
  "mttnsubadgp",
  "mttnsubcmp",
  "mttnsubkw",
  "mttnsubpid",
  "mttnsubplmnt",
  "mttnsubsite",
  "gclid"
];
var PROCESS_REDIRECT_URL_ENDPOINT = "https://itunes.apple.com/WebObjects/MZStoreServices.woa/wa/processRedirectUrl";
var METRICS_REGISTER_ENDPOINT = "https://xp.apple.com/register";
var TV_AFFILIATIONS_ENDPOINT = "https://buy.tv.apple.com/account/v1/affiliation/association";
var MUSIC_AFFILIATIONS_ENDPOINT = "https://buy.music.apple.com/account/v1/affiliation/association";

// src/utils.js
function addHeadersToRequest(request, headers) {
  if (headers && typeof headers === "object") {
    for (const prop in headers) {
      if (headers[prop]) {
        request.setRequestHeader(prop, headers[prop]);
      }
    }
  }
}
function cookieStringFromResponse(cookie) {
  return Object.keys(cookie).reduce((memo, key) => {
    if (["name", "value"].includes(key)) {
      return memo;
    }
    return `${memo};${key}=${cookie[key]}`;
  }, `${cookie.name}=${cookie.value}`);
}
function hasQueryParams(url, _params) {
  const rawQuery = url.indexOf("?") > -1 ? url.split("?")[1] : url;
  const queries = rawQuery.split("&");
  let params = _params;
  if (!params) {
    params = [];
  }
  if (url && url.trim() !== "") {
    for (let i = 0; i < queries.length; i++) {
      const param = queries[i].split("=");
      const key = param[0];
      const value = param[1];
      if (params.indexOf(key) > -1) {
        if (key === "at") {
          if (value.match(/^[a-zA-Z0-9]+$/)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    }
  }
  return false;
}
function promisifyXHR(xhr, data) {
  return new Promise(function(resolve, reject) {
    xhr.onload = function() {
      if (xhr.status < 200 || xhr.status >= 300) {
        reject({ request: xhr });
      } else {
        resolve(xhr);
      }
    };
    xhr.onerror = function() {
      reject({ request: xhr });
    };
    if (data) {
      xhr.send(data);
    } else {
      xhr.send();
    }
  });
}

// src/index.js
function makeRegisterRequest() {
  const registerRequest = new XMLHttpRequest();
  registerRequest.open("GET", METRICS_REGISTER_ENDPOINT);
  registerRequest.withCredentials = true;
  return promisifyXHR(registerRequest);
}
function makeProcessRedirectRequest(url, endpoint, options) {
  let request;
  if (options.customXhr) {
    request = options.customXhr;
  } else if (typeof itms !== "undefined") {
    request = itms.makeStoreXMLHttpRequest();
  } else {
    request = new XMLHttpRequest();
  }
  request.open("POST", endpoint);
  request.withCredentials = true;
  addHeadersToRequest(request, {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
  });
  addHeadersToRequest(request, options.headers);
  let data = "url=" + encodeURIComponent(url);
  if (options.ignoreMarketing) {
    data += "&ignoreMarketing=true";
  }
  return promisifyXHR(request, data).then(function(xhr) {
    const response = xhr.response;
    const status = xhr.status;
    if (status === 200 && response !== "") {
      const result = JSON.parse(response);
      if (result.setCookies) {
        result.setCookies.forEach((cookie) => {
          document.cookie = cookieStringFromResponse(cookie);
        });
      }
      return result.redirectUrl;
    }
  });
}
function handleCampaignAndAffiliateUrls(url, _options) {
  const options = _options || {};
  if (!hasQueryParams(url, KNOWN_CAMPAIGN_AND_AFFILIATE_QUERY_PARAMS)) {
    return Promise.reject("No campaign or affiliate query params found");
  }
  const endpoint = options.endpoint || PROCESS_REDIRECT_URL_ENDPOINT;
  return makeRegisterRequest().then(function() {
    return makeProcessRedirectRequest(url, endpoint, options);
  });
}
var src_default = handleCampaignAndAffiliateUrls;
export {
  KNOWN_CAMPAIGN_AND_AFFILIATE_QUERY_PARAMS,
  KNOWN_MARKETING_QUERY_PARAMS,
  METRICS_REGISTER_ENDPOINT,
  MUSIC_AFFILIATIONS_ENDPOINT,
  PROCESS_REDIRECT_URL_ENDPOINT,
  TV_AFFILIATIONS_ENDPOINT,
  src_default as default,
  handleCampaignAndAffiliateUrls
};
